var REM_TO_PX = 0.0625;
var GRID_SIZE = 8;
export var sizeToRem = function sizeToRem(size) {
  return "".concat(size * GRID_SIZE * REM_TO_PX, "rem");
};
export var pxToRem = function pxToRem(px) {
  return "".concat((px * REM_TO_PX).toFixed(3), "rem");
};